export const MOCK_INVENTORY_PRODUCTS = [
  {
    id: "prod-101",
    name: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    status: "Normal",
  },
  {
    id: "prod-102",
    name: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    status: "Normal",
  },
  {
    id: "prod-103",
    name: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    status: "Normal",
  },
  {
    id: "prod-104",
    name: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    status: "Normal",
  },
  {
    id: "prod-201",
    name: "Legacy Rotary Switch Type B",
    partNumber: "LS-ROT-B02",
    status: "End of Production", // Cannot receive purchase inventory
  },
  {
    id: "prod-202",
    name: "Vintage Fuse Box 60A",
    partNumber: "VT-FUS-60A",
    status: "End of Production", // Cannot receive purchase inventory
  },
];
